<section class="flex md:flex-row flex-col w-full justify-between items-center my-3 gap-3">
  <section class="relative flex w-full md:justify-start justify-between items-center gap-2">
    <button (click)="handleNavigate('prev', _mode()!, 1)" class="btn btn-ghost">
      <span class="icon-[mdi--chevron-left]"></span>
    </button>
    <button class="btn btn-ghost" [cdkMenuTriggerFor]="c">
      <p class="font-semibold text-base md:text-lg">
        {{ value() | date: 'y년 MM월' }}
      </p>
    </button>
    <button (click)="handleNavigate('next', _mode()!, 1)" class="btn btn-ghost">
      <span class="icon-[mdi--chevron-right]"></span>
    </button>
  </section>
  <section class="flex flex-row gap-3 items-center min-w-max w-full md:w-auto justify-between md:justify-start">
    <lepi-tabs [options]="modes" [value]="_mode() || 'month'" (valueChange)="handleModeChange($event)" />
    <ng-content />
  </section>
</section>

<ng-template #c>
  <div class="rounded-md shadow-md" cdkMenu>
    <lepi-pick-calendar [value]="value()" (valueChange)="handleDateChange($event!)" />
  </div>
</ng-template>